<template>
  <div id="app" class="layout-wrapper">
    <AppTopBar />
    <!--
    <div class="layout-sidebar" @click="onSidebarClick">
        <AppMenu  />
    </div>
    -->

    <div class="layout-main-container">
      <div class="layout-main">
        <!-- <NavBar /> -->
        <router-view/>
      </div>
      <AppFooter />
    </div>
  </div>
</template>
<script>
// @ is an alias to /src


import AppTopBar from './AppTopBar.vue'
import AppFooter from './AppFooter.vue'
//import AppMenu from './AppMenu.vue'
import NavBar from '@/components/NavBar.vue'

export default {
  components: {
    AppTopBar,
    AppFooter,
    //AppMenu,
    NavBar
  },
  data () {
    return {
      layoutMode: 'static',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      visibleLeft: true
    }
  },
  methods: {
    onMenuToggle() {
        this.menuClick = true;
        if (this.isDesktop()) {
            if (this.layoutMode === 'overlay') {
                if(this.mobileMenuActive === true) {
                    this.overlayMenuActive = true;
                }
                this.overlayMenuActive = !this.overlayMenuActive;

                this.mobileMenuActive = false;
            }
            else if (this.layoutMode === 'static') {
                this.staticMenuInactive = !this.staticMenuInactive;
            }
        }
        else {
            this.mobileMenuActive = !this.mobileMenuActive;
        }
        event.preventDefault();
    },
    isDesktop() {
      return window.innerWidth >= 992;
    }
  }
}
</script>

<style type="text/css">

html {
    font-size: 13px;
}

</style>
